import { Device } from "@core/models/domain/device.domain";
export interface DeviceState {
  devices: Device[];
  // Cache metadata consumed by the loadDevicesIfNeeded effect (see device.effects.ts).
  loaded: boolean;
  lastLoadedAt: number | null;
  loading: boolean;
  error: any;
}

export const initialDeviceState: DeviceState = {
  devices: [],
  loaded: false,
  lastLoadedAt: null,
  loading: false,
  error: null,
};